const tipos_polizas = state => state.tipos_polizas;
const tipo_cuenta_contable = state => state.tipo_cuenta_contable;
const cuenta_contable = state => state.cuenta_contable;
const cuentas_contables = state => state.cuentas_contables;
const ejercicios = state => state.ejercicios;

export default {
  tipos_polizas,
  tipo_cuenta_contable,
  cuenta_contable,
  cuentas_contables,
  ejercicios,
};
